import React from "react";
import DashboardIcon from "@mui/icons-material/Dashboard";
import GroupIcon from "@mui/icons-material/Group";
import StorageIcon from "@mui/icons-material/Storage";
import WorkIcon from "@mui/icons-material/Work";
import ApprovalIcon from "@mui/icons-material/Approval";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import InventoryIcon from "@mui/icons-material/Inventory";
import AccountCircle from "@mui/icons-material/AccountCircle";
import LogoutIcon from "@mui/icons-material/Logout";
import LanguageIcon from '@mui/icons-material/Language';

export const adminActionItems = [
  {
    id: "DASHBOARD",
    title: "Dashboard",
    sideNavTitle: "Dashboard",
    icon: <DashboardIcon />,
    navigateTo: "/admin/dashboard",
    bgcolor: "#F6CA9F",
    color: "#B7793D",
  },
  {
    id: "DASHBOARD_SUPPLIER",
    title: "Dashboard Supplier",
    sideNavTitle: "Dashboard Supplier",
    icon: <DashboardIcon />,
    navigateTo: "/admin/supplier-dashboard",
    bgcolor: "#F6CA9F",
    color: "#B7793D",
    displayInSideNav: true,
  },
  {
    id: "USER_MANAGEMENT",
    title: "User Management",
    sideNavTitle: "User Management",
    icon: <GroupIcon />,
    navigateTo: "/admin/user-management",
    bgcolor: "#CDE4F0",
    color: "#467289",
    displayInSideNav: true,
    displayInGrid: false,
  },
  {
    id: "MY_PROFILE",
    title: "My Profile",
    sideNavTitle: "My Profile",
    icon: <AccountCircle />,
    navigateTo: "/admin/my-profile",
    bgcolor: "#CDE4F0",
    color: "#467289",
  },
  {
    id: "LOGOUT",
    title: "Logout",
    sideNavTitle: "Logout",
    icon: <LogoutIcon />,
    onClickFunc: "logout",
    bgcolor: "#CDE4F0",
    color: "#467289",
  },
  {
    id: "COMPLETED_JOBS",
    title: "Completed Jobs",
    sideNavTitle: "Completed Jobs",
    icon: <CheckCircleIcon />,
    navigateTo: "/admin/completed-jobs",
    bgcolor: "#CDE4F0",
    color: "#467289",
    displayInSideNav: true,
  },
  {
    id: "SUPPLIER_COMPLETED_JOBS",
    title: "Supplier Completed Jobs",
    sideNavTitle: "Supplier Completed Jobs",
    icon: <CheckCircleIcon />,
    navigateTo: "/admin/supplier-completed-jobs",
    bgcolor: "#CDE4F0",
    color: "#467289",
    displayInSideNav: true,
  },
];

export const actionItems = [
  {
    id: "DASHBOARD",
    title: "Dashboard",
    sideNavTitle: "Dashboard",
    icon: <DashboardIcon />,
    navigateTo: "/dashboard",
    bgcolor: "#F6CA9F",
    color: "#B7793D",
  },
  {
    id: "WEBSITE",
    title: "Website",
    sideNavTitle: "Website",
    icon: <LanguageIcon />,
    externalLink: "https://logopromo.com.au/my-account/",
    bgcolor: "#F6CA9F",
    color: "#B7793D",
    displayInSideNav: true,
    displayInGrid: false,
  },
  {
    id: "NEW_JOB",
    title: "New Job",
    sideNavTitle: "New Job",
    icon: <WorkIcon />,
    navigateTo: "/jobs/add",
    bgcolor: "#F6CA9F",
    color: "#B7793D",
    displayInSideNav: false,
    displayInGrid: false,
  },
  {
    id: "MY_PROFILE",
    title: "My Profile",
    sideNavTitle: "My Profile",
    icon: <AccountCircle />,
    navigateTo: "/my-profile",
    bgcolor: "#CDE4F0",
    color: "#467289",
  },
  {
    id: "LOGOUT",
    title: "Logout",
    sideNavTitle: "Logout",
    icon: <LogoutIcon />,
    onClickFunc: "logout",
    bgcolor: "#CDE4F0",
    color: "#467289",
  },
  {
    id: "COMPLETED_JOBS",
    title: "Completed Jobs",
    sideNavTitle: "Completed Jobs",
    icon: <CheckCircleIcon />,
    navigateTo: "/completed-jobs",
    bgcolor: "#CDE4F0",
    color: "#467289",
    displayInSideNav: true,
  },
];

export const getSidenavItems = (idList, isAdminOrEmp, role) => {
  let finalActionItems = (isAdminOrEmp === 1 || role === 4) ? adminActionItems : actionItems;

  let sidenavItems = [];
  if (role !== 4) {
    sidenavItems.push({
      ...finalActionItems[0],
      title: role === 2 ? (finalActionItems[0].sideNavTitle + " Client") : finalActionItems[0].sideNavTitle,
      sideNavTitle: role === 2 ? (finalActionItems[0].sideNavTitle + " Client") : finalActionItems[0].sideNavTitle,
    });
  }

  finalActionItems.forEach((action) => {
    if (action.displayInSideNav && idList.includes(action.id)) {
      let sideNavItem = {
        ...action,
        title: action.sideNavTitle,
      };

      if (sideNavItem.children && !sideNavItem.displayChildrenInSideNav) {
        delete sideNavItem.children;
      }

      sidenavItems.push(sideNavItem);
    } else if (action.id === "DASHBOARD_SUPPLIER" && (role === 1 || role === 2 || role === 4)) {
      let sideNavItem = {
        ...action,
        title: action.sideNavTitle,
      };
      sidenavItems.push(sideNavItem);
    }
  });

  let userActionItems = finalActionItems.filter((item) => item.id === "MY_PROFILE" || item.id === "LOGOUT");

  userActionItems.forEach((uAction) => {
    sidenavItems.push(uAction);
  });

  return sidenavItems;
};
